import React, { useContext, useState } from 'react';
import AppContext from "../../AppContext";
import { SelectGen, InputDiv, Error } from "../utils/Utils";
import { FormService, Lang, Config, Api } from "./../../services/Services";
import { BaseSubmit, RegiBtns } from "./../utils/Utils";

const langText = (area, term, fallback) => {
	if (Lang[area] && Lang[area][term]) {
		return Lang[area][term];
	}
	return fallback;
};

const InitSecondHandAccount = ({ activationCode, onBack, onPaymentSuccess }) => {
	const context = useContext(AppContext);
	const months = Array(12).fill(true).map((it, k) => k + 1).map(it => ({ key: it, value: it }));
	const thisYear = (new Date()).getFullYear();
	const years = Array(10).fill(true).map((it, k) => k + thisYear).map(it => ({ key: it, value: it }));

	const fieldsObj = {};
	fieldsObj.activationCode = useState((activationCode || context.UserService.activationCode || "").toUpperCase());
	fieldsObj.invoiceEmail = useState("");
	fieldsObj.creditCard = useState("");
	fieldsObj.month = useState(1);
	fieldsObj.year = useState(thisYear);
	fieldsObj.cvv = useState("");
	const [errors, errorsUpd] = useState({});
	const [servError, servErrorUpd] = useState(null);
	const [submitDisabled, submitDisabledUpd] = useState(false);
	const [showSuccess, showSuccessUpd] = useState(false);

	const fields = [
		{ name: "activationCode", validation: { notEmpty: true, activationCode: true }, toUpperCase: true, placeholder: langText("forgot_username", "label_activation_code", "Activation code") },
		{ name: "invoiceEmail", type: "email", validation: { isEmail: true, notEmpty: true }, toLowerCase: true, placeholder: langText("second_hand_account", "label_invoice_email", "Email for invoice") },
		{ name: "creditCard", placeholder: "#", validation: { notEmpty: true, length: 16 } },
		{ name: "month", type: "select", opts: months, validation: {} },
		{ name: "year", type: "select", opts: years, validation: {} },
		{ name: "cvv", placeholder: "###", validation: { notEmpty: true, length: 3 } },
	];
	FormService.fieldsHoist(fields, fieldsObj);

	const submitFunc = async () => {
		servErrorUpd(null);
		if (FormService.validateEntireFormHooks(fields, errorsUpd)) {
			return;
		}
		submitDisabledUpd(true);

		const sendObj = {
			activetionKey: fieldsObj.activationCode[0].trim(),
			invoiceEmail: fieldsObj.invoiceEmail[0].trim(),
			gopay: "pay",
			fldCardNumber: fieldsObj.creditCard[0],
			fldExpirationMon: fieldsObj.month[0],
			fldExpirationYear: fieldsObj.year[0],
			fldCardCVV: fieldsObj.cvv[0],
		};

		try {
			let res = await Api.secondHandCheckout(sendObj);
			if (typeof res === "string") {
				const start = res.lastIndexOf("{");
				if (start >= 0) {
					try { res = JSON.parse(res.slice(start)); } catch (parseErr) { /* keep string */ }
				}
			}
			if (res && res.success) {
				showSuccessUpd(true);
				return;
			}
			const errText = (res && (res.err || res.code)) ? String(res.err || res.code) : "";
			if (/אושר|approved/i.test(errText)) {
				showSuccessUpd(true);
				return;
			}
			submitDisabledUpd(false);
			if (res && res.code === "notActivated") {
				servErrorUpd(langText("errorTexts", "activation_fail", "This code is not in use. Please register."));
			} else {
				servErrorUpd(errText || langText("checkout_payment", "err_card_proc_faild", "Card processing failed"));
			}
		} catch (e) {
			const raw = e && e.response ? e.response.data : "";
			let parsed = raw;
			if (typeof raw === "string") {
				if (/אושר|approved/i.test(raw)) {
					showSuccessUpd(true);
					return;
				}
				const start = raw.lastIndexOf("{");
				if (start >= 0) {
					try { parsed = JSON.parse(raw.slice(start)); } catch (parseErr) { /* keep raw */ }
				}
			}
			if (parsed && parsed.success) {
				showSuccessUpd(true);
				return;
			}
			submitDisabledUpd(false);
			servErrorUpd(langText("checkout_payment", "err_card_proc_faild", "Card processing failed"));
		}
	};

	const goToRegister = () => {
		const code = fieldsObj.activationCode[0].trim();
		if (onPaymentSuccess) {
			onPaymentSuccess(code);
		}
	};

	if (showSuccess) {
		return (
			<>
				<h5>{langText("second_hand_account", "heading", "Init account - second hand product")}</h5>
				<p>{langText("second_hand_account", "payment_success_register", "Payment completed. Please register using the code on the back of the product.")}</p>
				<RegiBtns>
					<BaseSubmit onClick={goToRegister} label={langText("activate_login", "butten_register", "Register")} />
				</RegiBtns>
			</>
		);
	}

	return (
		<div className="checkout checkout-in-modal">
			<h5>{langText("second_hand_account", "heading", "Init account - second hand product")}</h5>
			<p>{langText("second_hand_account", "hint_activation_after_payment", "This activation code will be initialized after payment so you can register as the new owner.")}</p>
			<ul className="form">
				<li><InputDiv fieldObj={fields[0]} error={errors.activationCode} /></li>
				<li><InputDiv fieldObj={fields[1]} error={errors.invoiceEmail} /></li>
			</ul>
			<div className="payment-form">
				<div className="wrap-div-sp">
					<label>{langText("checkout_payment", "label_card_number", "Card number")}</label>
					<div>
						<InputDiv fieldObj={fields[2]} error={errors.creditCard} />
					</div>
				</div>
				<div className="exp-cont">
					<label>{langText("checkout_payment", "label_card_expiration", "Expiration")}</label>
					<div className="exp">
						<SelectGen fieldObj={fields[3]} />
						<SelectGen fieldObj={fields[4]} />
					</div>
				</div>
				<div className="cvv wrap-div-sp">
					<label>{langText("checkout_payment", "label_card_cvv", "CVV")}</label>
					<div>
						<InputDiv fieldObj={fields[5]} error={errors.cvv} />
					</div>
				</div>
				<div className="payment-cont">
					<h2>{langText("checkout_payment", "heading_total_sum", "Total")} : <span dangerouslySetInnerHTML={{ __html: Config.DEFAULT_CURRENCY_SYMBOL + "" + Config.SECOND_HAND_PRICE }}></span></h2>
					<Error err={servError} isBtn />
					<button className="btn" onClick={submitFunc} disabled={submitDisabled}>
						{langText("second_hand_account", "button_pay", langText("checkout_payment", "butten_submit", "Pay"))}
					</button>
					<p>
						<span className="form-p underline pointer" onClick={onBack}>{langText("activate1", "butten_back", "Back")}</span>
					</p>
				</div>
			</div>
			<div className="payment-bottom">
				<div className="img-div">
					<a href="#"><img src="/assets/images/godaddysecured.png" alt="godaddy verified and secured" /></a>
					<a href="#"><img src="/assets/images/mcafee.png" alt="mcafee security" /></a>
				</div>
			</div>
		</div>
	);
};

export default InitSecondHandAccount;
